<template>
<!-- 	title="舆情报送" -->
	<el-dialog  :visible.sync="dialogVisible" width="60%" :before-close="handleClose" class="report-news" :close-on-click-modal="false">
		<span slot="title" class="dialog-title">
		   <span><i class="iconfont iconyqbsbt shangbao-icon" style="color:#fff;"></i>舆情报送</span>
		  </span>
		<div>
			<el-form :model="yqsb" :rules="rules" ref="yqsb" label-width="0px">
				<el-row>
					<el-col :span="12" class="pad-left">
						<el-row>
							<el-col>
								<span class="label-text">
									<!-- <img src="~@/assets/img/monitoring/tanchuang/sbzt.png" alt="" /> -->
									<i class="iconfont iconshangbaozhuanti shangbao-icon"></i>
									上报专题
								</span>
							</el-col>
							<el-col>
								<el-form-item label="" prop="taskName" class="taskName">
									<!--<el-select v-model="yqsb.taskName" placeholder="请选择上报专题">
										<el-option v-for="item in regions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
									-->
									<el-select prop="taskName" v-model="yqsb.taskName" filterable @change="changeTask" style="width: 252px;float: left;height: 32px;" ref="taskId" size="small" placeholder="请选择上报专题...">
										<el-option-group
												v-for="item in taskList"
												:key="item.title"
												:label="item.title" v-if="item.children.length>0">
											<el-option
													v-for="g in item.children"
													:key="g.id"
													:label="g.title"
													:value="g.id">
											</el-option>
										</el-option-group>
								</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="12" class="textOverOneLine link-col">
						<span>
							<!-- <img src="~@/assets/img/monitoring/tanchuang/yqlj.png" alt="" /> -->
							<i class="iconfont iconwangzhi shangbao-icon"></i>
							<a :href="yqsb.url" target="_blank">{{yqsb.url}}</a>
						</span>
					</el-col>
				</el-row>
				<el-row class="mt-10">
					<el-col>
						<span class="label-text">
							<!-- <img src="~@/assets/img/monitoring/tanchuang/yqbt.png" alt="" /> -->
							<i class="iconfont iconyuqingbiaoti shangbao-icon"></i>
							舆情标题
						</span>
					</el-col>
					<el-col>
						<el-form-item label="" prop="title"><el-input v-model.trim="yqsb.title"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-row class="pad-left">
							<el-col>
								<span class="label-text">
									<!-- <img src="~@/assets/img/monitoring/tanchuang/fbsj.png" alt="" /> -->
									<i class="iconfont icontime shangbao-icon" style="font-size: 20px;"></i>
									发表时间
								</span>
							</el-col>
							<el-col>
								<el-form-item label="" prop="publishTime">
									<el-date-picker v-model="yqsb.publishTime" type="datetime" placeholder="选择日期时间" prefix-icon="iconfont iconrili"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="12">
						<el-row>
							<el-col>
								<span class="label-text">
									<!-- <img src="~@/assets/img/monitoring/tanchuang/lywz.png" alt="" /> -->
									<i class="iconfont iconlaiyuanwangzhan shangbao-icon"></i>
									来源网站
								</span>
							</el-col>
							<el-col>
								<el-form-item label="" prop="website"><el-input v-model.trim="yqsb.website"></el-input></el-form-item>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-row class="pad-left">
							<el-col>
								<span class="label-text">
								<!-- 	<img src="~@/assets/img/monitoring/tanchuang/ssdq.png" alt="" /> -->
									<i class="iconfont iconlaiyuan shangbao-icon"></i>
									涉事地区
								</span>
							</el-col>
							<el-col>
								<el-form-item label="" prop="belongArea" class="belongArea">
									<!--<el-select v-model="yqsb.region" placeholder="请选择涉事地区">
										<el-option v-for="item in regions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>-->
									<el-cascader
											style="float: left;height: 32px;"
											change-on-select
											:options="cityList"
											v-model="areaIds"
											:props="defaultProps"
											@change="handleChangeCity">
									</el-cascader>

								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="12">
						<el-row>
							<el-col>
								<span class="label-text">
									<!-- <img src="~@/assets/img/monitoring/tanchuang/yqjb.png" alt="" /> -->
									<i class="iconfont iconxing1 shangbao-icon"></i>
									舆情级别
								</span>
							</el-col>
							<el-col>
								<el-form-item label="" prop="degree">
									<el-select v-model="yqsb.degree" placeholder="请选择舆情级别">
										<el-option v-for="item in levels" :key="item.value" :label="item.name" :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-form-item prop="content">
					<el-row>
						<el-col>
							<span class="label-text">
								<!-- <img src="~@/assets/img/monitoring/tanchuang/yqzy.png" alt="" /> -->
								<i class="iconfont iconyuqingzhaiyao shangbao-icon"></i>
								舆情摘要
							</span>
						</el-col>
						<el-col>
							<el-input type="textarea" class="titleMatch" placeholder="请输入标题关键词，并以|线分隔 " v-model.trim="yqsb.content" resize="none"></el-input>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer textR">
			<el-button type="primary" @click="add" class="btn">
				<!-- <img src="~@/assets/img/monitoring/fenxibaogao/queding.png" alt="" /> -->
				<i class="iconfont iconqueding btn-icon"></i>
				确 认
			</el-button>
		</span>


		<tool-tip-prop2 ref="toolTipProp2"></tool-tip-prop2>
	</el-dialog>



</template>

<script>
    import { construct, destruct } from '@aximario/json-tree';
    import reportApi from '@/api/report';
export default {
	data() {
		return {
			dialogVisible: false,
            /**舆情上报*/
            yqsb: {
                // taskId:null,//专题ID
                // taskTypeId:null,//专题ID
                // taskName:null,//专题名称
                // url:null,//舆情链接
                // website:null,//来源网站、网站
                // belongArea:null,
                // belongAreaProvinceId:null,//涉事地区(省ID)
                // belongAreaCityId:null,//涉事地区(市ID)
                // belongAreaCountyId:null,//涉事地区(区县ID)

                // degree:'',//舆情等级 重大舆情
                // publishTime:null,//发表时间
                // title:null,//舆情标题
                // belongAreaId: '',//地区
                // content: '',//概要
                // rid:'',
				taskId:'',//专题ID
				taskTypeId:'',//专题ID
				taskName:'',//专题名称
				url:'',//舆情链接
				website:'',//来源网站、网站
				belongArea:'',
				belongAreaProvinceId:'',//涉事地区(省ID)
				belongAreaCityId:'',//涉事地区(市ID)
				belongAreaCountyId:'',//涉事地区(区县ID)
				
				degree:'',//舆情等级 重大舆情
				publishTime:'',//发表时间
				title:'',//舆情标题
				belongAreaId: '',//地区
				content: '',//概要
				rid:'',
            },
			rules: {
                taskName: [{ required: true, message: '请输入上报专题', trigger: 'change' }],
                publishTime: [{ required: true, message: '请输入发表时间', trigger: 'change' }],
                content: [{ required: true, message: '请输入舆情摘要', trigger: 'blur' }],
                degree: [{ required: true, message: '请输入舆情级别', trigger: 'change' }],
                belongArea: [{ required: true, message: '请选择涉事区域', trigger: 'change' }],
                website: [{ required: true, message: '请输入来源网站', trigger: 'blur' }],
				title: [{ required: true, message: '请输入舆情标题', trigger: 'blur' }]
			},
			regions: [{ value: '1', label: '商厦' }, { value: '2', label: '上海' }, { value: '3', label: '福州' }, { value: '4', label: '厦门' }],
            /*舆情级别*/
            levels:[

            ],
            /* {id:1,name:'特大舆情',label:'特大舆情',value:1},
               {id:2,name:'重大舆情',label:'重大舆情',value:2},
               {id:3,name:'一般舆情',label:'一般舆情',value:3},*/
            taskList:[],
            cityList:[],
            areaIds:[],
			areassoure:[],
            defaultProps: {
                children: 'children',
                value: 'id',
                name:'label',
            },
            checkUrlIsFlag:false
		};
	},
	created() {},
	mounted() {
	},
	methods: {
		handleClose(done) {
			this.dialogVisible = false;
			this.$refs['yqsb'].resetFields();
			
		    this.$reset('yqsb',['rules','cityList'])
		},
		show() {
			this.dialogVisible = true;
		},
        showToolTipProp2(tips) {
            this.$refs.toolTipProp2.show(tips);
        },
		add() {
            let _this = this;
			this.$refs['yqsb'].validate(valid => {
				if (valid) {
                    reportApi.addArticle({ doc:_this.yqsb}).then(res => {
						console.log(res)
						if(res.returnData.returnFlag == 1){
							//判断是否达上限 等于1 就是达上限了
							_this.$my_confirm(res.returnData.returnFlagMsg, {
								yesBtnText: '确定',
								type: 'tips'
							});
							return false
						}
                        if (res.returnCode == '100') {
                            _this.handleClose()
                            _this.$parent.singlepublicReportClose()
                        }else{
                            // _this.showToolTipProp2('该舆情已报送，请不要重复上报!');
							 _this.$my_confirm(res.returnMsg, {
								yesBtnText: '确定',
								type: 'tips'
							})
								.then(() => {
									//点登录
								})
								.catch(() => {
									//点取消
								});
						}
                    })
				} else {
					
					return false;
				}
			});
		},
        /*获取专题列表*/
        getTaskList(){
            let _this = this;
            reportApi.taskList({}).then(res => {
                if (res.returnCode == '1001') {
                    _this.taskList = res.returnData;
                }
            });
        },
        /*获取涉世地区*/
        getCityList(){
            let _this = this;
            reportApi.cityList({}).then(res => {
                if (res.returnCode == '1001') {
                    _this.areassoure = res.returnData
                    let result = construct(res.returnData, {
                        id: 'id',
                        pid: 'pId',
                        name:'name',
                        children: 'children'
                    });
					
                    _this.cityList = result
                }
            });
        },
        handleChangeCity(value){
            this.areaIds = value
            let _this = this
            value.forEach(function (item,index) {
                if(index == 0){_this.yqsb.belongAreaProvinceId = item}
                if(index == 1){_this.yqsb.belongAreaCityId = item}
                if(index == 2){_this.yqsb.belongAreaCountyId = item}
            })
            let p = _this.areassoure.find(s=>s.id == value[value.length-1])
            if(p){
                _this.yqsb.belongArea = p.label
            }
		},
        changeTask(value){
            let _this = this
            _this.taskList.forEach(function (item,index) {
				if(item.children!=null&&item.children.length>0){
                    item.children.forEach(function (childitem,index) {
						if(childitem.id==value){
                            _this.yqsb.taskTypeId = childitem.pid
                            _this.yqsb.taskId = childitem.id
                            _this.yqsb.taskName = childitem.title
						}
                    })
				}
            })
		},
		initData(item){
            let reportItem=JSON.parse(JSON.stringify(item));

            reportItem.title = this.$utils.handleRmoveText(reportItem.title);
            reportItem.content = this.$utils.handleRmoveText(reportItem.content);

            this.yqsb.url=reportItem.url//舆情链接
            this.yqsb.website=reportItem.websiteName//来源网站、网站
            this.yqsb.title=reportItem.title//来源网站、网站
            this.yqsb.content=reportItem.content//来源网站、网站
			this.yqsb.publishTime=reportItem.pageTime
            this.getDictionaryList()
			this.getTaskList()
            this.getCityList()

		},
        /*获取舆情级别*/
        getDictionaryList(){
            let _this = this;
            let data={
                key:'grade'
			}
            reportApi.dictionaryList(data).then(res => {
                if (res.returnCode == '100') {
                    _this.levels = res.returnData
					
                }
            });
        },
		/*,
        async checkUrl(url){
            let _this = this
			await _this.checkUrlFlag(url)
			
			return _this.checkUrlIsFlag;
		},
		checkUrlFlag(url){
            let _this = this
            reportApi.checkUrl({ url:url}).then(res => {
                if(res.returnData.flag==1){
                    _this.checkUrlIsFlag=true
				}else{
                    _this.checkUrlIsFlag=false
				}
            })
		}*/
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {
				if (val) {
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	}
};
</script>

<style lang="less">
.report-news {
	.el-dialog__body {
		padding: 10px 60px;
	}
	.el-dialog {
		min-width: 812px;
	}
	.el-dialog .el-dialog__header {
		//background-image: url(~@/assets/img/monitoring/tanchuang/yqbs-icon1.png);
		// background-repeat: no-repeat;
		// background-origin: content-box;
		//text-indent: 25px;
	}
    .dialog-title{
		color:#fff;
		font-size: 14px;
	}
	.titleMatch .el-textarea__inner {
		height: 200px;
	}
	.el-select {
		width: 100%;
	}
	.el-date-editor.el-input {
		width: 100%;
	}
	.label-text {
		font-family: MicrosoftYaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #666666;
		line-height: 32px;
	}
	.el-form-item {
		margin-bottom: 12px;
	}
	.link-col {
		a{
			padding-top: 44px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #2f9af5;
		}
		padding-top: 44px;
		font-family: MicrosoftYaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #2f9af5;
	}
	.pad-left {
		padding-right: 40px;
		.taskName{
			.el-select{
				width: 100%!important;
				height: 40px!important;
			}
		}
		.belongArea{
			.el-cascader{
				width: 100%!important;
				height: 40px!important;
			}
		}
	}
	.el-dialog__footer {
		text-align: right;
		padding-bottom: 20px;
		padding-right: 60px;
		.btn {
			width: 218px;
			height: 40px;
			background-color: #0092f1;
			border-radius: 4px;
		}
	}
	// .el-form-item__content{
	// 	position: static;
	// }
	.mt-10{
		margin-top: 10px;
	}
}
</style>
